module.exports = __webpack_public_path__ + "static/media/LHAInSwingDark.f55520f2.svg";